import { NgModule } from '@angular/core';

import { EventListRoutingModule, FixtureListRoutingModule } from './event-list-routing.module';

@NgModule({
    imports: [EventListRoutingModule],
})
export class EventListModule {}

@NgModule({
    imports: [FixtureListRoutingModule],
})
export class FixtureListModule {}
